import styled from 'styled-components';
import media from '../theme/media';
import { fontSans, fontMono } from '../theme/config';

export const Label = styled.span`
  color: #b3bac1;
  display: block;
  font-family: ${fontSans};
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
`;

export const Subheader = styled.span`
  font-family: ${fontSans};
  color: #787f8c;
  font-size: 20px;
  line-height: 1;
  font-weight: 400;
  letter-spacing: 0.016em;
  margin-bottom: .5rem;
`;

export const Caption = styled.span`
  font-family: ${fontSans};
  font-weight: 500;
  font-size: 1rem;
  text-transform: none;
  letter-spacing: 0;
  margin: 0 auto;
  text-align: center;
  display: block;
  padding-top: 1rem;
  color: #979b9f;
  font-style: italic;
`;

export const LinkCustom = styled.a`
  position: relative;
  font-weight: 400;
  line-height: 24px;
  width: fit-content;
  width: -moz-fit-content;
  display: inline-block;
  border-bottom: 1px solid #CED4DA;
  &:after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 0%;
    border-bottom: 2px solid #000000;
    transition: 0.4s;
  }
  &:hover:after { 
    width: 100%; 
    ${media.small`
      width: 0;
    `}
  }
  ${media.small`
    font-size: 1rem;
  `}
  &.mozilla {
    &:hover {
      color: #FF0900;
      ${media.small`
        color: #525252;
      `}
    }
    &:after {
      border-bottom: 2px solid #FF0900;
    }
  }
  &.everyaction {
    &:hover {
      color: #0077FF;
      ${media.small`
        color: #525252;
      `}
    }
    &:after {
      border-bottom: 2px solid #0077FF;
    }
  }
  &.skwiz {
    &:hover {
      color: #485CDC;
      ${media.small`
        color: #525252;
      `}
    }
    &:after {
      border-bottom: 2px solid #485CDC;
    }
  }
  &.amazon {
    &:hover {
      color: #f86b01;
      ${media.small`
        color: #525252;
      `}
    }
    &:after {
      border-bottom: 2px solid #f86b01;
    }
  }
  &.default {
    &:hover {
      color: #525252;
    }
    &:after {
      border-bottom: 2px solid #000000;
    }
  }
`;

export const HeadingH1 = styled.h1`
  font-family: ${fontSans};
  font-weight: 700;
  font-size: 2.5rem;
  line-height: 3rem;
  ${media.small`
    font-size: 1.75rem;
    line-height: 2.25rem;
  `}
`;

export const HeadingH2 = styled.h2`
  font-family: ${fontMono};
  text-transform: uppercase;
  font-weight: 700;
  color: #0077FF;
  letter-spacing: 2px;
  font-size: 1rem;
  margin: 0;
  display: block;
  line-height: 1.5rem;
  ${media.small`
    margin: 0 auto;
  `}
  &.mozilla {
    color: #FF0900;
  }
  &.skwiz {
    color: #485CDC;
  }
  &.default {
    color: #000000;
  }
  &.amazon {
    color: #f86b01;
  }
`;

export const DropCap = styled.span`
  font-size: 48px;
  font-weight: 700;
  line-height: 48px;
  margin: 0;
  float: left;
  padding-right: 8px;
  color: #1E1F21;
  ${media.small`
    font-size: inherit;
    float: none;
    margin: 0;
    padding: 0;
    color: inherit;
    font-weight: 400;
    line-height: inherit;
  `}
`;

export const BulletedList = styled.ul`
  font-size: 1rem;
  margin: 2.25rem 0;
  li { margin-left: 1.5rem}
  b, p {
    font-size: 1rem;
  }
`;


// WEBPACK FOOTER //
// src/theme/typography.js